import { render, staticRenderFns } from "./LogoUploader.vue?vue&type=template&id=42e5c6a1&"
import script from "./LogoUploader.vue?vue&type=script&lang=js&"
export * from "./LogoUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports